import * as React from "react";
import { Link, type LinkProps } from "@tanstack/react-router";
import { NumPill } from "./num-pill";
import { cn } from "@/lib/utils";

export interface SidebarNavItemProps {
  to: LinkProps["to"];
  icon: React.ReactNode;
  label: string;
  count?: number;
  active?: boolean;
}

export function SidebarNavItem({ to, icon, label, count, active }: SidebarNavItemProps) {
  return (
    <Link
      to={to}
      className={cn(
        "flex items-center gap-2 rounded-2 px-2 py-1.5 text-[12.5px]",
        active ? "bg-p-100 font-medium text-p-700" : "text-ink-700 hover:bg-surface-1",
      )}
    >
      <span
        className={cn("inline-flex size-4 items-center justify-center", active && "text-p-600")}
      >
        {icon}
      </span>
      <span className="flex-1">{label}</span>
      {typeof count === "number" ? (
        active ? (
          <NumPill inverted className="bg-p-600 text-white">
            {count}
          </NumPill>
        ) : (
          <NumPill>{count}</NumPill>
        )
      ) : null}
    </Link>
  );
}
